<ion-header>
  <app-header pageName="Select Device">
    <ion-buttons end>
      <ion-button slot="icon-only" fill="clear" (click)="onClose()" class="ion-padding-left">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </app-header>
</ion-header>

<ion-content forceOverflow="false">
  <div>
    <p class="message">{{message}}</p>
  </div>
  <div class="buttons">
    <ion-button class="primary" (click)="selectOption('Other')">{{ 'OTHER' | translate }}</ion-button>
    <ion-button class="success" (click)="selectOption('true')"> {{ 'PRINT' | translate }} </ion-button>
  </div>
</ion-content>